export const TempApprovePopup = () => import("@users/components/modals/TempApprovePopup.vue");

export default { TempApprovePopup };
